import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BrandMark } from '../components/Header';
import { useCommerce } from '../contexts/CommerceContext';
import { isSupabaseConfigured, supabase } from '../services/supabase';

export function AuthPage() {
  const { signIn, signUp, user } = useCommerce();
  const navigate = useNavigate();
  const [mode, setMode] = useState<'signin' | 'signup'>('signin');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [pending, setPending] = useState(false);

  if (user) {
    return <main className="auth-page"><div className="auth-card"><BrandMark /><CheckCircle2 size={32} /><h1>Você já está conectada.</h1><Link className="button button-dark" to="/minha-conta">Minha conta</Link></div></main>;
  }

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setMessage('');
    if (mode === 'signup' && password !== confirmPassword) {
      setMessage('As senhas não coincidem.');
      return;
    }
    setPending(true);
    const error = mode === 'signin' ? await signIn(email, password) : await signUp(name, phone, email, password);
    setPending(false);
    if (error) {
      setMessage(error);
      return;
    }
    if (mode === 'signup') setMessage('Cadastro criado. Confirme seu e-mail para concluir o acesso.');
    else navigate('/minha-conta');
  };

  const resetPassword = async () => {
    if (!email) {
      setMessage('Informe seu e-mail para receber o link de recuperação.');
      return;
    }
    if (!supabase) {
      setMessage('Configure o Supabase para habilitar a recuperação de senha.');
      return;
    }
    const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: `${window.location.origin}/entrar` });
    setMessage(error ? error.message : 'Enviamos um link de recuperação para seu e-mail.');
  };

  const continueWithGoogle = async () => {
    setMessage('');
    if (!supabase) {
      setMessage('Configure o Supabase para habilitar o acesso com Google.');
      return;
    }
    setPending(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/minha-conta` },
    });
    if (error) {
      setPending(false);
      setMessage(error.message);
    }
  };

  const changeMode = (nextMode: 'signin' | 'signup') => {
    setMode(nextMode);
    setMessage('');
  };

  return <main className="auth-page"><div className="auth-card">
    <Link to="/" className="auth-brand"><BrandMark /></Link>
    <p className="eyebrow">Minha conta</p>
    <h1>{mode === 'signin' ? 'Boas-vindas de volta.' : 'Crie sua conta.'}</h1>
    <p className="muted">{mode === 'signin' ? 'Entre para acompanhar seus pedidos e salvar favoritos.' : 'Crie sua conta para acompanhar pedidos e salvar favoritos.'}</p>
    {!isSupabaseConfigured && <p className="config-note">A autenticação por e-mail e Google ficará disponível após inserir as variáveis do Supabase.</p>}
    <div className="auth-tabs">
      <button className={mode === 'signin' ? 'is-selected' : ''} onClick={() => changeMode('signin')}>Entrar</button>
      <button className={mode === 'signup' ? 'is-selected' : ''} onClick={() => changeMode('signup')}>Criar conta</button>
    </div>
    <button type="button" className="google-button" disabled={pending} onClick={continueWithGoogle}>
      <span className="google-mark" aria-hidden="true">G</span>
      {pending ? 'Redirecionando…' : 'Continuar com Google'}
    </button>
    <div className="auth-divider"><span>ou use seu e-mail</span></div>
    <form onSubmit={submit} className="auth-form">
      {mode === 'signup' && <>
        <label>Nome<input required value={name} onChange={(event) => setName(event.target.value)} autoComplete="name" /></label>
        <label>Telefone<input required value={phone} onChange={(event) => setPhone(event.target.value)} inputMode="tel" autoComplete="tel" /></label>
      </>}
      <label>E-mail<input required type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" /></label>
      <label>Senha<input required minLength={6} type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoComplete={mode === 'signin' ? 'current-password' : 'new-password'} /></label>
      {mode === 'signup' && <label>Confirmar senha<input required minLength={6} type="password" value={confirmPassword} onChange={(event) => setConfirmPassword(event.target.value)} autoComplete="new-password" /></label>}
      {mode === 'signin' && <button type="button" className="text-button" onClick={resetPassword}>Esqueci minha senha</button>}
      {message && <p className="form-message">{message}</p>}
      <button disabled={pending} className="button button-dark full-width" type="submit">{pending ? 'Aguarde…' : mode === 'signin' ? 'Entrar' : 'Criar conta'} <ArrowRight size={17} /></button>
    </form>
  </div></main>;
}
